import React, {createContext, useState} from 'react'

import { Route, Switch, withRouter } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { CSSPlugin } from "gsap/all";
import Home from "./pages/Home";
import Studio from "./pages/Studio";
import ProjectInner from "./pages/ProjectInner";
import News from "./pages/News";
import NewsInner from "./pages/NewsInner";
import Contact from "./pages/Contact";

import styled from 'styled-components';
import Nav from "./components/shared/Nav";
import { KeywordsProvider } from './contexts/KeywordsProvider';

// Timeline register plugin so it works
let plugins = [CSSPlugin];
// Removing eslint error
plugins.inject = true;

const App = withRouter(({ location }) => {
  return (
    <KeywordsProvider>
        <Nav location={location} />
        <AnimatedSwitch />
    </KeywordsProvider>
  )
});

const AnimatedSwitch = withRouter(({ location }) => {
  return (
    <TransitionGroup>
      <CSSTransition key={location.key} classNames="fade" timeout={1000}>
        <PageContent>
          <Switch location={location}>
            <Route path="/" component={Home} exact />
            <Route path="/me" component={Home} exact />
            <Route path="/en" component={Home} exact />
            <Route path="/me/projekat/:projectLink" component={ProjectInner} />
            <Route path="/en/project/:projectLink" component={ProjectInner} />
            <Route path="/me/studio" component={Studio} />
            <Route path="/en/studio" component={Studio} />
            <Route path="/me/novosti" component={News} exact />
            <Route path="/en/news" component={News} exact />
            <Route path="/me/novosti/:articleLink" component={NewsInner} />
            <Route path="/en/news/:articleLink" component={NewsInner} />
            <Route path="/me/kontakt" component={Contact} />
            <Route path="/en/contact" component={Contact} />
          </Switch>
        </PageContent>
      </CSSTransition>
    </TransitionGroup>
  )
});

const PageContent = styled.div`
  position: absolute;
  width: 100%;
`

export default App;
